import { Textarea } from 'components/Form'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from 'components/ModalV2/Modal'
import React, { useState } from 'react'
import { Button } from 'styling/GlobalStyles'
import { WorkflowResolutionStatus } from 'types/procurement/enums'

export const ResolveWithCommentModal = ({
  onClose,
  resolutionStatus,
  handleRequest,
}: {
  onClose: () => void
  resolutionStatus: WorkflowResolutionStatus
  handleRequest: (comment: string) => void
}) => {
  const [comment, setComment] = useState('')
  return (
    <Modal onClose={onClose}>
      <ModalContent>
        <ModalHeader>
          {resolutionStatus === WorkflowResolutionStatus.Approved
            ? 'Approve Step'
            : resolutionStatus === WorkflowResolutionStatus.Rejected
            ? 'Reject Step'
            : 'Request Changes'}
        </ModalHeader>
        <ModalBody>
          <Textarea
            label='Add a comment'
            placeholder='Enter comment'
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cancel</Button>
          <Button orange onClick={() => handleRequest(comment)}>
            Resolve
          </Button>{' '}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
